<template>
	<section id="appli" class="item" :class="bg">
		<div class="container">
			<h2>L'application</h2>
			<div class="row">
				<div class="col-12 col-md-6">
					<p class="mb-3">Chaque acteur de la copropriété (syndic bénévole, conseillers syndicaux, copropriétaires) dispose d’un accès spécifique.</p>
					<p class="mb-3 mb-sm-0">En toute transparence, l'application permet à chacun de consulter les informations et documents le concernant.</p>

					<!--						productive-->
				</div>
				<div class="col-12 col-md-6">
					<p class="mb-3">Accessible à tout moment, où que vous soyez, grâce à une simple connexion internet (sans installation) avec tous vos appareils.</p>
					<p class="mb-3 mb-sm-0">L'interface intuitive permet une utilisation accessible à tous.</p>
<!--					simple et efficace,-->


					<!--						<p class="mb-3">Nous répondons présent pour vous assister.</p>-->
<!--					<p class="mb-3">-->
						<!--							Notre <router-link to="#devis">formule tout inclus</router-link> vous offre un accès-->

						<!--								accessible uniquement par vous.-->
						<!--								un support par téléphone (de 9h à 19h, du lundi au samedi) et par e-mail-->
<!--					</p>-->
				</div>
			</div>
		</div>
	</section>

</template>
<style lang="scss" scoped>
</style>
<script>
	export default{
		metaInfo() {
			if(!this.meta) return {};

			return {
				title: "L'application",
				meta: [
					{name: 'description', content: 'Avec CoproPrivée, les syndics bénévoles, conseillers syndicaux, copropriétaires accèdent aux informations et documents les concernants grâce à une simple connexion internet.', id: 'desc'},
				]
			}
		},
		props:{
			meta:{default:true},
			bg:{default:null}
		}
	}
</script>
